import styled from "styled-components";

export const SectionObjectivesContainer = styled.section(() => ({}));

export const SectionObjectivesContent = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "32px",
  marginBottom: "20px",

  [theme.breakpoint.lg()]: {
    gap: "40px",
    marginBottom: "60px",
  },
}));

export const SectionObjectivesTitle = styled.h2(({ theme }) => ({
  fontSize: "28px",
  fontWeight: "700",
  lineHeight: "150%",
  color: theme.color.brandPrimary.light,
  margin: 0,

  [theme.breakpoint.lg()]: {
    fontSize: "40px",
  },
}));

export const SectionObjectivesText = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "30px",
  color: theme.color.neutral["02"],

  p: {
    margin: 0,
    fontSize: "20px",
    fontWeight: "500",
    lineHeight: "160%",
  },
}));

export const SectionObjectivesList = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: "32px",

  [theme.breakpoint.lg()]: {
    flexDirection: "row",
  },
}));

export const SectionObjectivesItem = styled.div(({ theme }) => ({
  display: "flex",
  gap: "16px",
  maxWidth: "100%",
  width: "100%",

  [theme.breakpoint.xl()]: {
    maxWidth: "48%",
    gap: "32px",
  },
}));

export const SectionObjectivesItemContent = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",

  width: "100%",
}));

export const SectionObjectivesItemTitle = styled.h3(({ theme }) => ({
  color: theme.color.neutral["02"],
  margin: 0,

  [theme.breakpoint.lg()]: {
    fontSize: "24px",
  },
}));

export const SectionObjectivesItemDescription = styled.p(({ theme }) => ({
  color: theme.color.neutral["02"],
  margin: 0,

  [theme.breakpoint.lg()]: {
    fontSize: "20px",
  },
}));
